import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__images">
          <div className="product-detail__main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
          {product.images.length > 1 && (
            <div className="product-detail__thumbnails">
              {product.images.map((image, index) => (
                <button
                  key={index}
                  className={`product-detail__thumbnail ${
                    selectedImage === index ? "active" : ""
                  }`}
                  onClick={() => setImage(index)}
                >
                  <img src={image} alt={`${product.name} ${index + 1}`} />
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="product-detail__info">
          <h1 className="product-detail__title">{product.name}</h1>
          <p className="product-detail__price">${product.price}</p>

          <div className="product-detail__details">
            <p className="product-detail__detail-item">
              <span>Era:</span> Contemporary, by Tuddlepetgoods
            </p>
            <p className="product-detail__detail-item">
              <span>Materials:</span> {product.material}
            </p>
            {product.size.length > 0 && (
              <div className="product-detail__section">
                <p className="product-detail__section-title">Size:</p>
                <div className="product-detail__options">
                  {product.size.map((size) => (
                    <button
                      key={size}
                      className={`product-detail__option ${
                        selectedSize === size ? "active" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {product.colors.length > 0 && (
              <div className="product-detail__section">
                <p className="product-detail__section-title">Color:</p>
                <div className="product-detail__options">
                  {product.colors.map((color) => (
                    <button
                      key={color}
                      className={`product-detail__option ${
                        selectedColor === color ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                    >
                      {color}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="product-detail__production-note">
            <p>*Please allow 6-8 weeks for production</p>
          </div>

          <button
            className="product-detail__add-to-cart"
            onClick={handleAddToCart}
          >
            ADD TO CART · ${product.price}
          </button>

          {product.description.length > 0 && (
            <div className="product-detail__description">
              <h3>Description</h3>
              {product.description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          )}

          {product.Features.length > 0 && (
            <div className="product-detail__features">
              <h3>Features</h3>
              <ul>
                {product.Features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
